import { useTaskPanel } from '../components/SecondaryHeader/features/Tasks/store/taskPanel'
import {
  useGetMostRecentInteractionByContactsQuery,
  useGetNotesByContactsQuery,
  useGetTaskCountsQuery
} from '../store/dynamics'
import { useRdot360AccountContext } from '../store/rdot360Context/useRdot360AccountContext'
import { useRdot360ClientContext } from '../store/rdot360Context/useRdot360ClientContext'
import { useRdot360HouseholdContext } from '../store/rdot360Context/useRdot360HouseholdContext'

const useSecondaryHeaderData = () => {
  const { isHouseholdFetching } = useRdot360HouseholdContext()
  const { isAccountsFetching } = useRdot360AccountContext()
  const { contactsIds, isContactsFetching } = useRdot360ClientContext()
  const { isLoading: isNotesByContactsFetching } = useGetNotesByContactsQuery(
    { contactIds: contactsIds },
    {
      skip: !contactsIds || !contactsIds.length
    }
  )

  const { isLoading: isInteractionsLoading } =
    useGetMostRecentInteractionByContactsQuery(contactsIds, {
      skip: !contactsIds || !contactsIds.length
    })

  const { getEndDate, getStartDate } = useTaskPanel()

  const { isFetching: isImmediateFetching } = useGetTaskCountsQuery(
    {
      contactIds: contactsIds,
      startDate: getStartDate('immediate'),
      endDate: getEndDate('immediate')
    },
    {
      skip: !contactsIds || !contactsIds.length
    }
  )
  const { isFetching: isFutureFetching } = useGetTaskCountsQuery(
    {
      contactIds: contactsIds,
      startDate: getStartDate('future'),
      endDate: getEndDate('future')
    },
    {
      skip: !contactsIds || !contactsIds.length
    }
  )
  const { isFetching: isAllFetching } = useGetTaskCountsQuery(
    { contactIds: contactsIds },
    {
      skip: !contactsIds || !contactsIds.length
    }
  )

  const getLoadingStatus = () => {
    const isLoading =
      isHouseholdFetching ||
      isAccountsFetching ||
      isNotesByContactsFetching ||
      isContactsFetching ||
      isInteractionsLoading ||
      isAllFetching ||
      isFutureFetching ||
      isImmediateFetching

    return isLoading
  }

  return {
    isLoading: getLoadingStatus()
  }
}

export default useSecondaryHeaderData
